module.exports = __webpack_public_path__ + "static/media/practical_case.e2802678.png";